import { SHOW_DOCUMENT_FORM, HIDE_DOCUMENT_FORM, SHOW_DOCUMENT_PREVIEW, HIDE_DOCUMENT_PREVIEW } from './types'

const initialState = {
  form: {
    show: false,
    data: {},
  },
  preview: {
    show: false,
    data: {},
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_DOCUMENT_FORM:
      return {
        ...state,
        form: {
          show: true,
          data: action.data
        }
      };
    case HIDE_DOCUMENT_FORM:
      return {
        ...state,
        form: {
          show: false,
          data: {}
        }
      };
    case SHOW_DOCUMENT_PREVIEW:
      return {
        ...state,
        preview: {
          show: true,
          data: action.data
        }
      };
    case HIDE_DOCUMENT_PREVIEW:
      return {
        ...state,
        preview: {
          show: false,
          data: {}
        }
      };
    default:
      return state;
  }
};

export default reducer;
